module.exports = __webpack_public_path__ + "media/עקרב.58ebdfc1.mp3";